import React from 'react';
import PropTypes from 'prop-types';
import { Image } from 'react-bootstrap-5';
import IntegrationsModal from './integration_modal';

import contactIcon from '../images/contact_integration.svg';
export default class CancelCalendarModal extends React.Component {

  static propTypes = {
    shown: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
  };

  handleSave = () => {
    const { onSave } = this.props;
    return onSave('contacts');
  }

  render() {
    const { shown, onCancel } = this.props;

    return (
      <IntegrationsModal
        disconnectModal
        shown={shown}
        title="Disconnect Your Contact Sync"
        onCancel={onCancel}
        onSave={this.handleSave}
      >
        <div className="text-center">
          <div className="mb-3">
            <div className="bg-body-tertiary border rounded p-2 d-inline-flex">
              <Image alt="Contact integration" height={40} src={contactIcon} width={40} />
            </div>
          </div>
          <span className="text-muted">
            Your contacts will no longer sync with your Google, Office, ICloud or Yahoo account
          </span>
        </div>
      </IntegrationsModal>
    );
  }
}
